/**
 * The "?" of every screen (header button and the "?" key): the training video of this screen — when there is one and
 * the user may watch it — with links to the guide chapter and to all the videos. Screens without a video go straight
 * to their guide chapter (the old behaviour).
 */
import { Link } from 'react-router';
import { BookOpen, PlayCircle } from 'lucide-react';
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { TrainingPlayer } from '@/components/TrainingPlayer';
import type { TrainingVideo } from '@shared/training.ts';

export function HelpDialog({ video, guideHref, open, onOpenChange }: {
  video: TrainingVideo; guideHref: string; open: boolean; onOpenChange: (o: boolean) => void;
}) {
  const close = () => onOpenChange(false);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent wide={!video.portrait}>
        <DialogHeader>
          <DialogTitle>{video.title}</DialogTitle>
          <DialogDescription>סרטון הדרכה · <bdi>{video.length}</bdi> דקות</DialogDescription>
        </DialogHeader>
        <DialogBody className="pb-4">
          {/* mounted only while open: closing the dialog stops the video */}
          {open ? <TrainingPlayer video={video} autoPlay /> : null}
        </DialogBody>
        <DialogFooter>
          <Button asChild variant="outline"><Link to={guideHref} onClick={close}><BookOpen /> הסבר כתוב במדריך</Link></Button>
          <Button asChild variant="ghost"><Link to="/help" onClick={close}><PlayCircle /> כל סרטוני ההדרכה</Link></Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
